import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  state: {
    orderId: null,
    id: null,
    name: null,
    discountInfo: null,
    datetime: null,
    limit: null,
    prices: [],
    seats: [],
    selectedSeats: [],
    dimensions: {
      top_min: 0,
      top_max: 0,
      left_max: 0,
      left_min: 0,
    },
    seatHeight: 40,
    seatWidth: 40
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/seat/index.js